"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WindowDimensionsContext = void 0;

var _react = require("react");

var WindowDimensionsContext = (0, _react.createContext)({
  width: null,
  height: null,
  deviceWidth: null,
  deviceHeight: null
});
exports.WindowDimensionsContext = WindowDimensionsContext;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/context/WindowDimensionsContext.js
// module id = 360
// module chunks = 209 210 211 212